import { FormattedMessage } from 'react-intl'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import TriplePointTakeoverLogo from './TriplePointTakeoverLogo'

function TriplePointTakeoverBannerContent() {
  const [tier] = useCurrentLoyaltyTier()

  return <Group direction="horizontal" gap={12} verticalAlign="center">
    <TriplePointTakeoverLogo size="small" />
    <BodyText variant="medium" weight="bold" colour={`tier-${tier}-contrast`}>
      <FormattedMessage
        id="6-4namoBhrKOmuZ66ykb"
        defaultMessage="Enjoy triple Société Points on this limited-time offer."
        
      />
    </BodyText>
  </Group>
}

export default TriplePointTakeoverBannerContent
